import { useMutation } from '@apollo/client';

import { gql } from '../gql-tag';

export const chitchatResponseFragment = gql(`
  fragment ChitchatResponseFields on AgentChitChatResponse {
    sessionId
    reply
    isComplete
    slots
    conversation {
      role
      content
    }
    currentStep
  }
`);

export const createChitchatMutation = gql(`
  mutation createChitchat($input: CreateAgentChitChatInput!) {
    createChitchat(input: $input) {
      chitchat {
        ...ChitchatResponseFields
      }
    }
  }
`);

export const updateChitchatMutation = gql(`
  mutation updateChitchat($input: UpdateAgentChitChatInput!) {
    updateChitchat(input: $input) {
      chitchat {
        ...ChitchatResponseFields
      }
    }
  }
`);

export const useCreateChitchat = () => {
  return useMutation(createChitchatMutation);
};

export const useUpdateChitchat = () => {
  return useMutation(updateChitchatMutation);
};
